export enum UserRole {
  Admin = 'Admin',
  BugoAgencyAdmin = 'BugoAgencyAdmin',
  BugoAgencyBranchAdmin = 'BugoAgencyBranchAdmin',
  BugoFuneralHome = 'BugoFuneralHome',
  BugoAgencyWorker = 'BugoAgencyWorker',
  BugoCustomer = 'BugoCustomer',
  BugoGuest = 'BugoGuest',
  StoreSeller = 'StoreSeller',
  StoreSellerAdmin = 'StoreSellerAdmin',
  StoreSellerWorker = 'StoreSellerWorker',
  StoreCustomer = 'StoreCustomer',
  StoreGuest = 'StoreGuest',
  GiftAgent = 'GiftAgent',
}

export enum DeliveryState {
  BEFORE_PREPARING = 'BeforePreparing',
  PREPARING = 'Preparing',
  DELIVERYING = 'Deliverying',
  DELIVERED = 'Delivered',
}

export enum PaymentState {
  NOT_PAID = 'NotPaid',
  WAITING = 'Waiting',
  PAID = 'Paid',
  CANCEL_REQUESTED = 'CancelRequested',
  CANCELED = 'Canceled',
  CONFIRMED = 'Confirmed',
}

export enum Gender {
  Male = '남',
  Femail = '여',
}

export type CustomCallback<A, T> = (e: A) => Promise<T> | T;

export type FeventDate = {
  date: Date | null;
  timeDefined: boolean;
};

export enum LowerRole {
  Admin = 'admin',
  NonAdmin = 'non-admin',
  BugoAgencyAdmin = 'bugo-agency-admin',
  BugoAgencyBranchAdmin = 'bugo-agency-branch-admin',
  BugoFuneralHome = 'bugo-funeralHome',
  BugoAgencyWorker = 'bugo-agency-worker',
  BugoCustomer = 'bugo-customer',
  BugoGuest = 'bugo-guest',
  StoreSeller = 'store-seller',
  StoreCustomer = 'store-customer',
  StoreGuest = 'store-guest',
  Public = 'public',
}

export enum CamelRole {
  Admin = 'admin',
  BugoAgencyAdmin = 'bugoAgencyAdmin',
  BugoFuneralHome = 'bugoFuneralHome',
  BugoAgencyWorker = 'bugoAgencyWorker',
  BugoCustomer = 'bugoCustomer',
  BugoGuest = 'bugoGuest',
  StoreSeller = 'storeSeller',
  StoreCustomer = 'storeCustomer',
  StoreGuest = 'storeGuest',
  Public = 'public',
}

export enum UserCustomTheme {
  Default = 'Default',
  Preed = 'Preed',
  Dark = 'Dark',
  DaeMyung = 'DaeMyung',
}

export enum AlertMethod {
  MESSAGE = 'Message',
  KAKAO = 'Kakao',
}

export enum UpsertMode {
  Update = 'Update',
  Insert = 'Insert',
}
